import { render, staticRenderFns } from "./PartnershipDetail.vue?vue&type=template&id=72244794&"
import script from "./PartnershipDetail.vue?vue&type=script&lang=js&"
export * from "./PartnershipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports